<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">

      <div class="flex flex-row padding10">
        <h5>Mailing Label Reports</h5>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
      'bg-gray-600': sharedService.userTheme === 'dark',
      'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col">

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <form [formGroup]="reportGroup" class="w-full">
                <table class="mat-elevation-z8 w-full">
                  <tr class="keyHeader">
                    <th>Report Name </th>
                    <th>State Name</th>
                    <th>Row Offset</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>Print Mailing Labels</td>
                    <td>
                      <mat-form-field Style="padding-right:20px">
                        <mat-label>Enter State Numbers (optional)</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="StateNumbers"></textarea>
                        <mat-error *ngIf="reportGroup.get('StateNumbers').invalid">
                          Cannot be longer than 4000 characters.
                        </mat-error>
                      </mat-form-field>
                    </td>
                    <td style="align-items: center;">
                      <mat-form-field>
                        <mat-label>Row Offset</mat-label>
                        <mat-select formControlName="RowOffset1">
                          <mat-option value="0">0</mat-option>
                          <mat-option value="1">1</mat-option>
                          <mat-option value="2">2</mat-option>
                          <mat-option value="3">3</mat-option>
                          <mat-option value="4">4</mat-option>
                          <mat-option value="5">5</mat-option>
                          <mat-option value="6">6</mat-option>
                          <mat-option value="7">7</mat-option>
                          <mat-option value="8">8</mat-option>
                          <mat-option value="9">9</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <div>
                        <button type="button" mat-raised-button color="primary" (click)="runReport1()">
                          Run Report
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr class="keyHeader">
                    <th>Report Name </th>
                    <th>Lab Type</th>
                    <th>Row Offset</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>Get All HST/SOA Labels</td>
                    <td>
                      <mat-form-field>
                        <mat-label>Lab Type</mat-label>
                        <mat-select formControlName="LabType">
                          <mat-option value="10" selected>HST</mat-option>
                          <mat-option value="30" selected>SOA</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field>
                        <mat-label>Row Offset</mat-label>
                        <mat-select formControlName="RowOffset2">
                          <mat-option value="0">0</mat-option>
                          <mat-option value="1">1</mat-option>
                          <mat-option value="2">2</mat-option>
                          <mat-option value="3">3</mat-option>
                          <mat-option value="4">4</mat-option>
                          <mat-option value="5">5</mat-option>
                          <mat-option value="6">6</mat-option>
                          <mat-option value="7">7</mat-option>
                          <mat-option value="8">8</mat-option>
                          <mat-option value="9">9</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <button type="button" mat-raised-button color="primary" (click)="runReport2()">
                        Run Report
                      </button>
                  </tr>
                </table>
              </form>
            </div>
          </div>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

</div>